import { render, staticRenderFns } from "./DeliverablesWidget.vue?vue&type=template&id=a50b639e"
import script from "./DeliverablesWidget.vue?vue&type=script&lang=js"
export * from "./DeliverablesWidget.vue?vue&type=script&lang=js"
import style0 from "./DeliverablesWidget.vue?vue&type=style&index=0&id=a50b639e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports